// 接口域名
const host = "";
const storageHost = host ? host : "";

export default {
  host: host,
  storage: storageHost,
};
